import React from "react";
import { useDispatch } from "react-redux";
import { filterAuthor, filterCetagory } from "../Redux/filter/action";

export default function Card({ blog }) {
  const { img, title, cetagory, author, date, reading } = blog;
  const dispatch = useDispatch();

  const filterAuthors = (authorId) => {
    dispatch(filterAuthor(authorId));
  };
  const filterCetagorys = (text) => {
    dispatch(filterCetagory(text));
  };

  return (
    <div className="flex flex-col rounded-lg shadow-lg overflow-hidden">
      <div className="flex-shrink-0">
        <img className="h-48 w-full object-cover" src={img} alt="" />
      </div>

      <div className="flex-1 bg-white p-6 flex flex-col justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-indigo-600">
            <span
              onClick={() => filterCetagorys(cetagory)}
              className="cursor-pointer inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-indigo-100 text-indigo-800"
            >
              {cetagory}
            </span>
          </p>
          <a href="#" className="block mt-1">
            <p className="text-xl font-semibold text-gray-900">{title}</p>
          </a>
        </div>
        <div className="mt-6 flex items-center">
          <div
            className="flex-shrink-0 cursor-pointer"
            onClick={() => filterAuthors(author.id)}
          >
            <img
              className="h-10 w-10 rounded-full"
              src={author.profile}
              alt=""
            />
          </div>
          <div className="ml-3">
            <p
              className="cursor-pointer text-sm font-medium text-gray-900 hover:underline cursor:pointer"
              onClick={() => filterAuthors(author.id)}
            >
              {author.name}
            </p>
            <div className="flex space-x-1 text-sm text-gray-500">
              <time>{date} </time>
              <span aria-hidden="true">&middot;</span>
              <span> {reading} </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
